import { createUseStyles } from "react-jss";
import { mediaQueries } from "../../../../../../../../common/constants";

export const MasterAppointmentBoardStyle = createUseStyles((theme: any) => ({
    form: {
        display: "flex",
        flexDirection: "row",
        gap: theme.gaps.form.column,
        paddingTop: 20,
        width: "100%",
    },
    row: {
        display: "flex",
        gap: theme.gaps.form.column,
        width: "100%",
        [mediaQueries.MOBILE]: {
            flexDirection: "column",
        },
    },
}));
